/**
 * ActionCommand
 *
 * Generic reversible action for cases that don't fit any of the typed
 * commands (behavior commit, transform, add/remove behavior, etc.).
 * Use this when you need to record an arbitrary undoable side effect —
 * for example, a preview-state reset that isn't a behavior commit but
 * still participates in the undo stack.
 *
 * Callers provide their own undo/redo closures; no coalescing.
 */

import type { UndoCommand } from './UndoCommand';

export class ActionCommand implements UndoCommand {
    readonly label: string;
    private _undo: () => void | Promise<void>;
    private _redo: () => void | Promise<void>;

    constructor(label: string, undoFn: () => void | Promise<void>, redoFn: () => void | Promise<void>) {
        this.label = label;
        this._undo = undoFn;
        this._redo = redoFn;
    }

    undo(): void | Promise<void> {
        return this._undo();
    }

    redo(): void | Promise<void> {
        return this._redo();
    }
}
